import PropTypes from 'prop-types'
import {
  CareerDot,
  CareerPageLocationContainer,
  CareerPageLocationInfoBlock,
} from '../styled'

export function LocationInfo({
  city = '',
  country = '',
  workplaceType = '',
  employmentType = '',
}) {
  const convertToNormalText = (input) =>
    input
      ?.split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')

  return (
    <CareerPageLocationContainer>
      <CareerPageLocationInfoBlock>
        {city && <span>{city}</span>}
        {city && <CareerDot />}
        {country && <span>{country}</span>}
        {country && <CareerDot />}
        {workplaceType && <span>{convertToNormalText(workplaceType)}</span>}
        {workplaceType && <CareerDot />}
        {employmentType && <span>{convertToNormalText(employmentType)}</span>}
      </CareerPageLocationInfoBlock>
    </CareerPageLocationContainer>
  )
}

LocationInfo.propTypes = {
  city: PropTypes.string,
  country: PropTypes.string,
  workplaceType: PropTypes.string,
  employmentType: PropTypes.string,
}
